import { AtIcon, CalendarIcon, PhoneIcon, UserIcon } from "@xola/icons";
import { Phone } from "@xola/ui-kit";
import clsx from "clsx";
import { formatDate } from "common";
import React from "react";
import { NoTranslate } from "../../Common/NoTranslate";

interface CustomerRecordSummaryProps {
    name: string;
    email: string;
    phone?: string;
    mergedAt?: string;
    boldName?: boolean;
}

// Shared contact-summary rows (name/email/phone/mergedAt) used by the merged-record card and the unmerge modal.
export const CustomerRecordSummary = ({ name, email, phone, mergedAt, boldName }: CustomerRecordSummaryProps) => {
    return (
        <div className="flex-col space-y-1 text-gray-darker">
            <NoTranslate as="div" className={clsx(boldName && "font-bold")}>
                <UserIcon className="mr-1" />
                {name}
            </NoTranslate>
            <NoTranslate as="div">
                <AtIcon className="mr-1" />
                {email}
            </NoTranslate>
            {phone && (
                <NoTranslate as="div">
                    <PhoneIcon className="mr-1" />
                    <Phone>{phone}</Phone>
                </NoTranslate>
            )}
            {mergedAt && (
                <div className="text-gray-dark">
                    <CalendarIcon className="mr-1" />
                    Merged on <var data-var="mergedAt">{formatDate(mergedAt)}</var>
                </div>
            )}
        </div>
    );
};
